import React, { useState, useEffect } from 'react'
import Page from 'contexts/page'
import NewsProvider, { useNews } from 'contexts/news'
import { useLocation } from 'react-router-dom'
import { useTimeout } from 'hooks/timeout'
import { compact } from 'utilities/object'
import HeroActions from 'components/hero-actions'
import { Articles, LoadingContainer } from './s'
import Loader from 'components/loader'
import Tutorial from 'components/tutorial'
import { Generic as Empty } from 'components/empty'
import Filter from './filter'

const PublishedPane = ({ salt }) => {
    const {
        articles,
        hasFetched,
        filter = {}
    } = useNews()

    const { state } = useLocation()

    const [revealTutorial, setRevealTutorial] = useState(false)
    const cancelRevealTutorial = useTimeout(() => setRevealTutorial(true), 500)

    useEffect(() => {
        if(articles.length > 0) {
            cancelRevealTutorial()
        }
    }, [articles?.length])

    const filtersApplied = !!Object.values(compact({
        ...filter,
        ...(state?.filter ?? null)
    })).flatMap(a => a).length

    return (
        <>
            <HeroActions>
                <Filter />
            </HeroActions>
            {!hasFetched && (
                <LoadingContainer>
                    <Loader />
                </LoadingContainer>
            )}
            {(hasFetched && !articles.length) && (
                <>
                    {!filtersApplied && (
                        <Tutorial
                            which="news"
                            show={revealTutorial} />
                    )}
                    {filtersApplied && <Empty />}
                </>
            )}
            <Articles salt={`${salt}:published`} />
        </>
    )
}

export default ({ title, upgradable, ...props }) => {
    const { state } = useLocation()

    return (
        <Page
            view="news_published"
            title={title}
            upgrade={{
                enabled: upgradable,
                tutorial: {
                    which: 'news',
                    upgrade: { module: 'news' }
                }
            }}>
            <NewsProvider {...(!!state?.filter ? { filter: state.filter } : null)}>
                <PublishedPane {...props} />
            </NewsProvider>
        </Page>
    )
}